<template>
  <div style="font-family: Arial, sans-serif; font-size: 13px; color: #333;">
    <div v-if="!incrementDetails" style="padding: 12px; color: #666;">
      Loading increment details...
    </div>

    <div v-else>
      <div style="border: 1px solid #E0E0E0; padding: 12px; margin-bottom: 12px; background: #f9fbff;">
        <div style="font-weight: bold; font-size: 14px; margin-bottom: 8px;">Employee Information</div>
        <div style="display: flex; flex-wrap: wrap; gap: 16px;">
          <div style="min-width: 220px;">
            <div style="margin-bottom: 4px;"><strong>Name:</strong> {{ this.incrementDetails?.employee?.name || "-"}}</div>
            <div style="margin-bottom: 4px;"><strong>Code:</strong> {{ this.incrementDetails?.employee?.code || "-" }}</div>
            <div style="margin-bottom: 4px;"><strong>Branch:</strong> {{ this.incrementDetails?.branch?.name || "-" }}</div>
          </div>
          <div style="min-width: 220px;">
            <div style="margin-bottom: 4px;"><strong>Department:</strong> {{ this.incrementDetails?.current_department?.name || "-" }}</div>
            <div style="margin-bottom: 4px;"><strong>Designation:</strong> {{ this.incrementDetails?.current_designation?.name || "-" }}</div>
            <div style="margin-bottom: 4px;"><strong>Mobile:</strong> {{ this.incrementDetails?.employee?.mobile || "-" }}</div>
          </div>
        </div>
      </div>

      <div style="display: flex; flex-wrap: wrap; gap: 12px; margin-bottom: 12px;">
        <div style="flex: 1; min-width: 300px; border: 1px solid #E0E0E0; padding: 10px;">
          <div style="font-weight: bold; margin-bottom: 8px;">Increment Summary</div>
          <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 6px;">
            <div><strong>Type</strong></div>
            <div>{{ formatValue(incrementDetails.increment_type) }}</div>
            <div><strong>Increment Amount</strong></div>
            <div>{{ formatValue(incrementDetails.increment_amount) }}</div>
            <div><strong>Increment Date</strong></div>
            <div>{{ formatDateDash(incrementDetails.increment_date) }}</div>
            <div><strong>Effect Date</strong></div>
            <div>{{ formatDateDash(incrementDetails.effect_date) }}</div>
          </div>
        </div>

        <div style="flex: 1; min-width: 300px; border: 1px solid #E0E0E0; padding: 10px;">
          <div style="font-weight: bold; margin-bottom: 8px;">Department & Designation</div>
          <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 6px;">
            <div><strong>Current Department</strong></div>
            <div>{{ this.incrementDetails?.current_department?.name || "-" }}</div>
            <div><strong>New Department</strong></div>
            <div>{{ this.incrementDetails?.new_department?.name || "-" }}</div>
            <div><strong>Current Designation</strong></div>
            <div>{{ this.incrementDetails?.current_designation?.name || "-" }}</div>
            <div><strong>New Designation</strong></div>
            <div>{{ this.incrementDetails?.new_designation?.name || "-" }}</div>
          </div>
        </div>
      </div>

      <table style="width: 100%; border-collapse: collapse; border: 1px solid #E0E0E0;">
        <thead>
          <tr>
            <th style="border: 1px solid #E0E0E0; padding: 6px; text-align: left; background: #f5f5f5;">Particular</th>
            <th style="border: 1px solid #E0E0E0; padding: 6px; text-align: right; background: #f5f5f5;">Current Salary</th>
            <th style="border: 1px solid #E0E0E0; padding: 6px; text-align: right; background: #f5f5f5;">Incremented Salary</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in salaryRows" :key="row.label">
            <td style="border: 1px solid #E0E0E0; padding: 6px;">{{ row.label }}</td>
            <td style="border: 1px solid #E0E0E0; padding: 6px; text-align: right;">{{ formatValue(row.current) }}</td>
            <td style="border: 1px solid #E0E0E0; padding: 6px; text-align: right;">{{ formatValue(row.incremented) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { formatDateDash } from '@/plugins/helpers';

export default {
  name: "hrmIncrementDetailsTable",
  data() {
    return {
      incrementDetails: null,
    };
  },
  computed: {
    salaryRows() {
      if (!this.incrementDetails) return [];

      return [
        { label: "Basic Salary", current: this.incrementDetails.current_salary?.basic_salary, incremented: this.incrementDetails.after_basic },
        { label: "House Rent", current: this.incrementDetails.current_salary?.house_rent, incremented: this.incrementDetails.after_house_rent },
        { label: "Medical", current: this.incrementDetails.current_salary?.medical, incremented: this.incrementDetails.after_medical },
        { label: "Conveyance", current: this.incrementDetails.current_salary?.conveyance, incremented: this.incrementDetails.after_conveyance },
        { label: "Others", current: this.incrementDetails.current_salary?.others, incremented: this.incrementDetails.after_others },
        { label: "PF / Provident Fund", current: this.incrementDetails.current_salary?.pf_provident_fund, incremented: this.incrementDetails.after_pf },
        { label: "Gross Salary", current: this.incrementDetails.current_salary?.gross_salary, incremented: this.incrementDetails.after_gross_salary },
      ];
    },
  },
  methods: {
    formatValue(value) {
      if (value === null || value === undefined || value === "") return "-";
      return value;
    },
    formatDateDash
  },
  mounted() {
    const id = this.$route.query.referenceable_id;

    if (id) {
      this.$store.dispatch("getIncrementById", id)
        .then((res) => {
          this.incrementDetails = res?.data;
          console.log(this.incrementDetails);
        })
    }
  },
};
</script>